/* FansBRANDS Support Chat V19 */
(function(){
  'use strict';
  var KEY='__fansbrandsSupportChatV19';
  var instances=new Map();

  function scan(){document.querySelectorAll('[data-fb-support]').forEach(init);}

  function init(root){
    if(root.dataset.fbSupportReady==='1')return;
    var core=window.FansBrandsOrderSupport;
    if(!core){console.error('FansBRANDS order support core is missing.');return;}
    root.dataset.fbSupportReady='1';

    var q=function(s,c){return(c||root).querySelector(s);};
    var qa=function(s,c){return[].slice.call((c||root).querySelectorAll(s));};
    var dialog=q('[data-fb-support-panel]');
    var launcher=q('[data-fb-support-toggle]');
    var close=q('[data-fb-support-close]');
    var back=q('[data-fb-support-track-back]');
    var scroll=q('[data-fb-support-scroll]');
    var menu=q('[data-fb-support-menu]');
    var tracker=q('[data-fb-support-tracker]');
    var title=q('[data-fb-support-title]');
    var eyebrow=q('[data-fb-support-eyebrow]');
    var intro=q('[data-fb-support-intro]');
    var form=q('[data-fb-support-form]');
    var primaryType=q('[data-fb-track-primary-type]');
    var primaryWrap=q('[data-fb-track-primary-wrap]');
    var primaryValue=q('[data-fb-track-primary-value]');
    var primaryLabel=q('[data-fb-track-primary-label]');
    var primaryHelp=q('[data-fb-track-primary-help]');
    var primaryChoices=qa('[data-fb-primary-choice]');
    var secondaryStep=q('[data-fb-track-secondary-step]');
    var secondaryType=q('[data-fb-track-secondary-type]');
    var secondaryWrap=q('[data-fb-track-secondary-wrap]');
    var secondaryValue=q('[data-fb-track-secondary-value]');
    var secondaryLabel=q('[data-fb-track-secondary-label]');
    var secondaryHelp=q('[data-fb-track-secondary-help]');
    var secondaryChoices=qa('[data-fb-secondary-choice]');
    var submit=q('[data-fb-track-submit]');
    var message=q('[data-fb-track-message]');
    var result=q('[data-fb-track-result]');
    var trackingApi=root.dataset.trackingApi||'';
    var whatsappUrl=root.dataset.whatsappUrl||'';
    if(!dialog||!launcher||!form)return;

    var request=null,sequence=0,timer=null,raf=0,baselineHeight=window.innerHeight;
    var buttonText='RENDELÉS ELLENŐRZÉSE';
    var abortController=new AbortController();
    var on=function(el,event,fn,opts){if(el)el.addEventListener(event,fn,Object.assign({signal:abortController.signal},opts||{}));};

    function abortRequest(){
      sequence++;
      if(request)request.abort();
      request=null;
      clearTimeout(timer);timer=null;
    }

    function clearFeedback(){
      abortRequest();
      message.hidden=true;message.textContent='';
      result.hidden=true;result.replaceChildren();
      primaryValue.removeAttribute('aria-invalid');secondaryValue.removeAttribute('aria-invalid');
      submit.disabled=false;submit.textContent=buttonText;form.removeAttribute('aria-busy');
    }

    function clearPressed(buttons){buttons.forEach(function(b){b.classList.remove('is-selected');b.setAttribute('aria-pressed','false');});}
    function setPressed(buttons,type,key){buttons.forEach(function(b){var selected=b.dataset[key]===type;b.classList.toggle('is-selected',selected);b.setAttribute('aria-pressed',selected?'true':'false');});}

    function resetForm(){
      clearFeedback();
      primaryType.value='';secondaryType.value='';
      primaryValue.value='';secondaryValue.value='';
      primaryValue.disabled=true;secondaryValue.disabled=true;
      primaryWrap.hidden=true;secondaryStep.hidden=true;secondaryWrap.hidden=true;submit.hidden=true;
      clearPressed(primaryChoices);clearPressed(secondaryChoices);
      secondaryChoices.forEach(function(b){b.hidden=false;});
      setKeyboardMode(false);
    }

    function view(name){
      var isTrack=name==='tracking';
      menu.hidden=isTrack;tracker.hidden=!isTrack;back.hidden=!isTrack;
      root.classList.toggle('is-tracking',isTrack);
      title.textContent=isTrack?'Hol a csomagom?':'Miben segíthetünk?';
      eyebrow.textContent=isTrack?'RENDELÉSKÖVETÉS':'GYORS SEGÍTSÉG';
      intro.textContent=isTrack?'Két adat alapján keressük meg a rendelést.':'Válaszd ki, miben segítsünk.';
      scroll.scrollTop=0;
      if(!isTrack){resetForm();}
      scheduleLayout();
    }

    function configure(which,type){
      var meta=core.fieldMeta[type];
      var input=which==='primary'?primaryValue:secondaryValue;
      var label=which==='primary'?primaryLabel:secondaryLabel;
      var help=which==='primary'?primaryHelp:secondaryHelp;
      if(!meta)return;
      core.configureInput(input,type);
      input.disabled=false;
      label.textContent=meta.prompt;
      help.textContent=meta.hint;
      input.removeAttribute('aria-invalid');
    }

    function revealInput(input){
      if(!input||!scroll)return;
      var sr=scroll.getBoundingClientRect();
      var ir=input.getBoundingClientRect();
      var topPad=12,bottomPad=16;
      if(ir.top<sr.top+topPad)scroll.scrollTop-=((sr.top+topPad)-ir.top);
      else if(ir.bottom>sr.bottom-bottomPad)scroll.scrollTop+=(ir.bottom-(sr.bottom-bottomPad));
    }

    function focusInput(input){
      if(!input)return;
      requestAnimationFrame(function(){
        try{input.focus({preventScroll:true});}catch(_){input.focus();}
        setTimeout(function(){revealInput(input);},260);
      });
    }

    function resetSecondary(primary){
      secondaryType.value='';secondaryWrap.hidden=true;secondaryValue.value='';secondaryValue.disabled=true;submit.hidden=true;
      clearPressed(secondaryChoices);
      secondaryChoices.forEach(function(button){button.hidden=button.dataset.fbSecondaryChoice===primary;});
    }

    function selectPrimary(type){
      clearFeedback();
      if(['order_number','email'].indexOf(type)===-1)return;
      primaryType.value=type;setPressed(primaryChoices,type,'fbPrimaryChoice');
      configure('primary',type);primaryWrap.hidden=false;secondaryStep.hidden=false;resetSecondary(type);
      focusInput(primaryValue);
    }

    function selectSecondary(type){
      clearFeedback();
      if(!core.fieldMeta[type]||type===primaryType.value)return;
      secondaryType.value=type;setPressed(secondaryChoices,type,'fbSecondaryChoice');
      configure('secondary',type);secondaryWrap.hidden=false;submit.hidden=false;
      focusInput(secondaryValue);
    }

    function error(text,input){
      message.textContent=text;message.hidden=false;result.hidden=true;
      if(input){input.setAttribute('aria-invalid','true');focusInput(input);}else message.scrollIntoView({block:'nearest',behavior:'smooth'});
    }

    function setKeyboardMode(active){
      if(window.innerWidth>767)active=false;
      var changed=root.classList.contains('is-keyboard')!==active;
      root.classList.toggle('is-keyboard',active);
      document.documentElement.classList.toggle('fb-support-keyboard-open',active);
      if(changed)requestAnimationFrame(function(){if(activeTrackingInput())revealInput(document.activeElement);});
    }

    function activeTrackingInput(){return document.activeElement===primaryValue||document.activeElement===secondaryValue;}

    function layout(){
      raf=0;
      var vv=window.visualViewport;
      var h=Math.round(vv?vv.height:window.innerHeight);
      root.style.setProperty('--fb-visible-height',h+'px');

      if(!activeTrackingInput()&&h>baselineHeight-40)baselineHeight=Math.max(baselineHeight,h);
      var keyboard=root.classList.contains('is-tracking')&&activeTrackingInput()&&window.innerWidth<=767&&(baselineHeight-h>100||window.innerHeight-h>100);
      setKeyboardMode(keyboard);

      if(window.innerWidth<=767){
        var nav=document.querySelector('#fbh .mobile');
        var min=parseFloat(getComputedStyle(root).getPropertyValue('--fb-mobile-bottom'))||94;
        var bottom=min;
        if(nav&&getComputedStyle(nav).display!=='none'){
          var r=nav.getBoundingClientRect();
          if(r.top<window.innerHeight&&r.bottom>0)bottom=Math.max(min,window.innerHeight-r.top+12);
        }
        // Raise the chat launcher above the product page's visible sticky purchase bar.
        // Use the actual bar position rather than a hardcoded height, so it also
        // works with different mobile widths, safe-area insets and text wrapping.
        var buybar=document.querySelector('[data-fb-ux-mobile-bar]');
        if(buybar&&document.body.classList.contains('fb-ux-mobile-sticky-visible')){
          var buybarRect=buybar.getBoundingClientRect();
          if(buybarRect.height>0&&buybarRect.top<window.innerHeight&&buybarRect.bottom>0){
            bottom=Math.max(bottom,Math.ceil(window.innerHeight-buybarRect.top+12));
          }
        }
        root.style.setProperty('--fb-effective-bottom',bottom+'px');
      }

    }

    function scheduleLayout(){if(!raf)raf=requestAnimationFrame(layout);}

    function open(){
      if(dialog.open)return;
      if(typeof dialog.show!=='function'){location.href=q('[data-fb-support-knowledge]').href;return;}
      instances.forEach(function(instance){if(instance.root!==root)instance.close();});
      baselineHeight=(window.visualViewport?window.visualViewport.height:window.innerHeight);
      resetForm();view('menu');layout();dialog.show();
      root.classList.add('is-open');launcher.setAttribute('aria-expanded','true');launcher.setAttribute('aria-label','Segítség bezárása');
      try{close.focus({preventScroll:true});}catch(_){close.focus();}
    }

    function finishClose(){
      resetForm();view('menu');root.classList.remove('is-open','is-tracking','is-keyboard');
      document.documentElement.classList.remove('fb-support-keyboard-open');
      launcher.setAttribute('aria-expanded','false');launcher.setAttribute('aria-label','Segítség megnyitása');
    }
    function closeDialog(){if(dialog.open)dialog.close();}
    function toggleDialog(){dialog.open?closeDialog():open();}

    on(launcher,'click',toggleDialog);on(close,'click',closeDialog);on(dialog,'close',finishClose);
    on(document,'keydown',function(e){if(e.key==='Escape'&&dialog.open){e.preventDefault();closeDialog();}});
    on(document,'pointerdown',function(e){if(dialog.open&&!dialog.contains(e.target)&&!launcher.contains(e.target))closeDialog();});
    on(q('[data-fb-support-track-open]'),'click',function(){view('tracking');try{back.focus({preventScroll:true});}catch(_){back.focus();}});
    on(back,'click',function(){view('menu');try{q('[data-fb-support-track-open]').focus({preventScroll:true});}catch(_){}});

    primaryChoices.forEach(function(button){on(button,'click',function(){selectPrimary(button.dataset.fbPrimaryChoice);});});
    secondaryChoices.forEach(function(button){on(button,'click',function(){selectSecondary(button.dataset.fbSecondaryChoice);});});

    [primaryValue,secondaryValue].forEach(function(input){
      on(input,'input',function(){clearFeedback();input.removeAttribute('aria-invalid');var type=input===primaryValue?primaryType.value:secondaryType.value;if(type==='order_number')input.value=core.normalize(type,input.value);});
      on(input,'focus',function(){scheduleLayout();setTimeout(function(){revealInput(input);},280);});
      on(input,'blur',function(){setTimeout(function(){if(!activeTrackingInput()){setKeyboardMode(false);scheduleLayout();}},220);});
    });

    on(form,'submit',async function(e){
      e.preventDefault();if(request)return;clearFeedback();
      var first=primaryType.value,second=secondaryType.value;
      if(['email','order_number'].indexOf(first)===-1){error('Először válaszd ki, hogy rendelési számmal vagy e-mail címmel keresel.');return;}
      if(!core.fieldMeta[second]||first===second){error('Válassz még egy ellenőrző adatot.');return;}
      var a=core.validate(first,primaryValue.value),b=core.validate(second,secondaryValue.value);
      if(a.error){error(a.error,primaryValue);return;}if(b.error){error(b.error,secondaryValue);return;}
      primaryValue.value=a.value;secondaryValue.value=b.value;
      var payload={};payload[first]=a.value;payload[second]=b.value;
      var endpoint;
      try{endpoint=new URL(trackingApi);if(endpoint.protocol!=='https:')throw new Error();}
      catch(_){error('A rendeléskereső nincs megfelelően beállítva. Kérj segítséget WhatsAppon.');return;}
      var n=++sequence;request=new AbortController();var timedOut=false;
      submit.disabled=true;submit.textContent='ELLENŐRZÉS...';form.setAttribute('aria-busy','true');
      timer=setTimeout(function(){timedOut=true;if(request)request.abort();},15000);
      try{
        var response=await fetch(endpoint.href,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:request.signal,credentials:'omit',cache:'no-store'});
        var data=await response.json();if(n!==sequence)return;
        if(!response.ok||!data||data.ok!==true){
          if(response.status===404)error(core.noMatchMessage(second));
          else if(response.status===429)error('Túl sok ellenőrzés történt. Várj egy percet, majd próbáld újra.');
          else error(typeof data.message==='string'?data.message:'Nem sikerült ellenőrizni a rendelést. Próbáld újra később.');
          return;
        }
        setKeyboardMode(false);if(document.activeElement&&typeof document.activeElement.blur==='function')document.activeElement.blur();
        core.renderOrder(result,data,{whatsappUrl:whatsappUrl,compact:true});
        result.scrollIntoView({block:'nearest',behavior:'smooth'});
      }catch(err){
        if(n!==sequence)return;
        if(timedOut)error('Az ellenőrzés túl sokáig tartott. Próbáld újra, vagy írj WhatsAppon.');
        else if(err.name!=='AbortError')error('Kapcsolati hiba történt. Ellenőrizd az internetkapcsolatot, majd próbáld újra.');
      }finally{
        if(n===sequence){clearTimeout(timer);request=null;submit.disabled=false;submit.textContent=buttonText;form.removeAttribute('aria-busy');}
      }
    });

    var knowledge=q('[data-fb-support-knowledge]');
    on(knowledge,'click',function(e){var search=document.querySelector('#fbh #search');if(!search)return;e.preventDefault();closeDialog();setTimeout(function(){search.scrollIntoView({block:'start',behavior:'smooth'});var input=search.querySelector('input');if(input)input.focus({preventScroll:true});},80);});

    on(window,'resize',scheduleLayout);on(window,'scroll',scheduleLayout);
    if(window.visualViewport){on(window.visualViewport,'resize',scheduleLayout);}
    var nav=document.querySelector('#fbh .mobile');
    var observer=nav&&'ResizeObserver'in window?new ResizeObserver(scheduleLayout):null;if(observer)observer.observe(nav);

    instances.set(root,{root:root,close:closeDialog,destroy:function(){abortRequest();if(dialog.open)dialog.close();document.documentElement.classList.remove('fb-support-keyboard-open');abortController.abort();if(observer)observer.disconnect();cancelAnimationFrame(raf);instances.delete(root);}});
    layout();
  }

  window[KEY]={scan:scan};
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',function(e){instances.forEach(function(instance){if(e.target.contains(instance.root))instance.destroy();});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
})();
